<script>
import NavDrawerProfileActionsContainer from '@components/layout/nav-drawer-profile-actions-container.vue'
import { mapGetters, mapActions } from 'vuex'
import baseMixin from '@/mixins/baseMixin'
import { LogoForm } from '@/shared/constants/assets/LogoForm'
import { LogoShade } from '@/shared/constants/assets/LogoShade'
import BaseLogo from '../_base-logo.vue'
import TheCreateBookingBtn from './the-create-booking-btn.vue'
import NavDrawerActionButton from './nav-drawer-action-button.vue'
import TheNavLinks from './the-nav-links.vue'
import NavDrawerLegalLinks from './nav-drawer-legal-links.vue'

export default {
  name: 'TheNavDrawer',
  components: {
    TheNavLinks,
    NavDrawerProfileActionsContainer,
    BaseLogo,
    TheCreateBookingBtn,
    NavDrawerActionButton,
    NavDrawerLegalLinks,
  },
  mixins: [baseMixin],
  props: {
    drawer: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      mini: 'isDrawerOpen',
    }),
    isMini() {
      return !this.isMobileViewPort && this.mini
    },
    compLogoForm() {
      return this.isMini ? LogoForm.ICON : LogoForm.NONE
    },
    compShade() {
      return this.isDarkMode ? LogoShade.LIGHT : LogoShade.DARK
    },
  },
  methods: {
    handleDrawer(event) {
      if (this.isMobileViewPort) return this.$emit('setDrawerState', event)
    },
    convertToActiveIcon(icon) {
      const strSplit = icon.split('-outline')
      return strSplit[0]
    },
    ...mapActions({
      toggleMiniDrawer: 'toggleDrawer',
    }),
  },
}
</script>

<template>
  <v-navigation-drawer
    v-if="!isMobileViewPort"
    id="main-navigation-drawer"
    app
    :hide-overlay="!isMobileViewPort"
    :value="drawer"
    bottom
    :temporary="isMobileViewPort"
    :mini-variant="isMini"
    :mini-variant-width="'64'"
    :width="'236'"
    disable-route-watcher
    :class="['nav-drawer sidebar', !isDarkMode ? 'white' : '']"
    @input="handleDrawer($event)"
  >
    <!-- Top Links to navigate -->
    <TheNavLinks />

    <template v-slot:prepend>
      <div
        :class="['d-flex', 'align-center', 'header-logo-icon']"
        :style="isMini ? 'width: 64px; padding: 12px 16px;' : ''"
      >
        <div
          v-if="!isMini"
          style="height: 24px"
          class="d-flex align-center justify-center me-4"
        >
          <BaseLogo
            :width="'72'"
            :height="'24'"
            :form="compLogoForm"
            :shade="compShade"
          />
        </div>

        <div
          :class="[
            'd-flex',
            'flex-wrap',
            'justify-content-between',
            isMini ? 'flex-column-reverse align-center' : '',
          ]"
          :style="isMini ? 'gap: 8px;' : 'gap: 10px;'"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <BaseButton
                id="navbar-toggler-icon"
                :icon="
                  isMini
                    ? 'mdi-chevron-double-right'
                    : 'mdi-chevron-double-left'
                "
                fab
                tertiary
                circle
                sm
                hover-color="blue400"
                v-bind="attrs"
                :border-radius="'8px'"
                :width="'32'"
                :height="'32'"
                @click.stop="toggleMiniDrawer"
                v-on="on"
              />
            </template>
            <span
              v-text="
                !isMini
                  ? $t('layout.drawerMinifierOpenTooltipText')
                  : $t('layout.drawerMinifierClosedTooltipText')
              "
            ></span>
          </v-tooltip>
        </div>
      </div>

      <TheCreateBookingBtn :mini="isMini" :extra-mini="isMini" />
    </template>

    <template v-if="!isMobileViewPort" v-slot:append>
      <div
        :class="{ 'align-content-end': mini }"
        :style="mini ? { minHeight: '233px' } : {}"
      >
        <!-- Setting & Help -->
        <NavDrawerActionButton />

        <v-divider
          :width="[mini ? '1px;' : '172px']"
          class="opacity-6 mt-2 mb-2 mx-auto"
        ></v-divider>
        <!-- Profile & Logout -->
        <NavDrawerProfileActionsContainer />

        <v-divider
          v-if="!mini"
          width="172px"
          class="opacity-6 mb-2 mx-auto mt-n2"
        ></v-divider>

        <NavDrawerLegalLinks v-if="!mini" />
      </div>
    </template>
  </v-navigation-drawer>
</template>

<style lang="scss" scoped>
@import '@styles';
@import '@/styles/nav-drawer.scss';
</style>
